<template>
  <section class="news-section">
    <div class="container">
      <div class="row title-wrapper">
        <div class="col-sm-6 wow fadeInLeft" data-wow-duration="2s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b8subtitle')" class="section-title">{{subtitle}}</span>
          <h3 v-bind="$parent.dKey('b8title')">{{title}}</h3>
        </div>
        <div class="col-sm-6 text-right p-0 wow fadeInRight" data-wow-duration="2s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b8titleRight')" class="big-title-st resp-number p-0">{{bgTitle}}</span>
        </div>
      </div>
      <div class="row news-overview-wrapper">
        <Article v-for="(post, index) in posts"
                 v-bind:key="index"
                 v-bind:title="post.title"
                 v-bind:content="post.content"
                 v-bind:href="post.url"
                 v-bind:image="post.image"
                 v-bind:date="post.date">
        </Article>
      </div>
    </div>
  </section>
</template>

<script>

import {HTTP} from '../../http-common'

import Article from '../Article.vue'

export default {
  name: 'News',

  props: ['title', 'subtitle', 'bgTitle'],

  data() {
    return {
      posts: [],
      errors: []
    }
  },

  created() {
    this.getNews()
  },

  watch:{
    $route (to, from) {
      this.getNews()
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  methods: {
    getNews() {
      HTTP.get('posts?filter=' + encodeURIComponent(JSON.stringify({
        where: {
          and: [
            {type: 'news'},
            {language_id: this.$root.language_id},
            {status: 'publish'}
          ]
        },
        order: 'date DESC',
        limit: 3
      }))).then(response => {
        if (response.status == 200) {
          this.posts = []

          response.data.forEach(post => {
            let article = post

            article.date = new Date(post.date)

            let day = article.date.getDate(),
                month = article.date.getMonth() + 1

            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day

            article.date = day + '.' + month + '.' + article.date.getFullYear()
            article.content = article.content.replace(/(<([^>]+)>)/ig, '')

            if (article.content.length > 106)
              article.content = article.content.substr(0, 106) + '...'

            article.url = '/' + this.$root.locale + '/news/' + article.url

            this.posts.push(article)
          })
        }
        // console.log(response)
      }).catch(e => {
        this.errors.push(e)
      })
    }
  },

  components: {
    Article
  }
}

</script>
